export const convertQuizScore = (score?: number): string => {
  return score ? (score * 100).toFixed(2) + ' %' : '0';
};
